<template>
  <el-row>
    <el-col :span="5">
      <basic-container>
        <avue-tree :option="treeOption" :data="treeData" @node-click="nodeClick" />
      </basic-container>
    </el-col>
    <el-col :span="19">
      <basic-container>
        <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-update="rowUpdate"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
        >
          <template slot="menu" slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-warning"
              @click.native="openCardeptEditDialog(0, scope.row)"
              >不可见
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-view"
              @click.native="openCardeptEditDialog(1, scope.row)"
              >查看
            </el-button>
            <el-button
              type="text"
              icon="el-icon-edit"
              size="small"
              @click.native="openCardeptEditDialog(2, scope.row)"
              >读写
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-refresh"
              @click.native="openCardeptEditDialog(3, scope.row)"
              >读写删
            </el-button>
          </template>
        </avue-crud>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import { add, getDetail, getList, remove, update } from '../api/authDept';
import { getDeptTree } from '@/api/v4ward/deptproperty/basedeptproperty';
import { mapGetters } from 'vuex';
import website from '@/config/website';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      init: {
        // roleTree: [],
        deptTree: [],
      },
      treeDeptId: '',
      treeDeptName: '',
      treeData: [],
      treeOption: {
        nodeKey: 'id',
        addBtn: false,
        menu: false,
        size: 'small',
        props: {
          labelText: '标题',
          label: 'title',
          value: 'value',
          children: 'children',
        },
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 18,
        //calcHeight: 30,
        tip: true,
        border: true,
        index: true,
        selection: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        refreshBtn: true,
        menuWidth: 300,
        stripe: true,
        dialogType: 'drawer',
        column: [
          {
            label: '养老院',
            prop: 'objectName',
            span: website.tenantMode ? 12 : 24,
            search: true,
          },

          {
            label: '养老院ID',
            prop: 'spaceId',
            hide: true,
          },
          {
            label: '小区id',
            prop: 'areaId',
            hide: true,
          },
          {
            label: '编号',
            prop: 'objectCode',
          },
          {
            label: '权限',
            prop: 'dataPower',
            dicData: [
              {
                label: '  ',
                value: -1,
              },
              {
                label: '不可见',
                value: 0,
              },
              {
                label: '查看',
                value: 1,
              },
              {
                label: '读写',
                value: 2,
              },
              {
                label: '读写删',
                value: 3,
              },
            ],
          },
          {
            label: 'id',
            prop: 'id',
            hide: true,
          },
          {
            label: '部门ID',
            prop: 'deptId',
            hide: true,
          },
          {
            label: '部门名称',
            prop: 'usableArea',
            hide: true,
          },
        ],
      },
      data: [],
    };
  },
  watch: {
    'form.tenantId'() {
      if (this.form.tenantId !== '') {
      }
    },
  },
  created() {
    this.initData();
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.crud.$children[1].$children[2].$el.addEventListener('click', () => {
          if (this.option.height == this.bodyHeight - 350) {
            this.option.height = this.bodyHeight - 290;
          } else {
            this.option.height = this.bodyHeight - 350;
          }
          this.$refs.crud.getTableHeight();
        });
      });
    });
    this.option.dialogHeight = this.bodyHeight - 360;
    this.option.height = this.bodyHeight - 350;
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.cardeptspace_add, false),
        viewBtn: this.vaildData(this.permission.cardeptspace_view, false),
        delBtn: this.vaildData(this.permission.cardeptspace_delete, false),
        editBtn: this.vaildData(this.permission.cardeptspace_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    nodeClick(data) {
      this.treeDeptId = data.id;
      this.treeDeptName = data.title;
      this.page.currentPage = 1;
      this.query = { deptId: data.id };
      this.onLoad(this.page);
    },
    initData() {
      getDeptTree().then((res) => {
        this.treeData = res.data;
      });
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    beforeOpen(done, type) {
      // if (['edit','view'].includes(type)) {
      //   getDetail(this.form.id).then(res => {
      //     this.form = res.data.data;
      //   });
      // }
      // done();
    },
    searchReset() {
      this.query = { deptId: this.treeDeptId };
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.data = [];
      if (this.vdui.isEmpty(this.query.deptId)) {
        this.$message.warning('请在左边选中一个组织后查询');
        done();
        return false;
      }
      this.query = Object.assign(params, { deptId: this.treeDeptId });
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad(this.page, { deptId: this.treeDeptId });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad(this.page, { deptId: this.treeDeptId });
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },

    openCardeptEditDialog(type, row) {
      let typeName;
      let treeDeptId = this.treeDeptId;
      if (0 === type) {
        typeName = '不可见';
      } else if (1 === type) {
        typeName = '查看';
      } else if (2 === type) {
        typeName = '读写';
      } else if (3 === type) {
        typeName = '读写删';
      }
      if (row.dataPower === type) {
        this.$message.warning('不能设置相同权限');
        return;
      }
      if (null === treeDeptId || 'undefined' == typeof treeDeptId || '' === treeDeptId) {
        this.$message.warning('请在左边选中一个组织');
        return;
      }

      this.$confirm('确定将该养老院权限修改为【' + typeName + '】？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (null === row.id || '' === row.id) {
            row.deptId = treeDeptId;
            row.usableArea = this.treeDeptName;
          }
          row.dataPower = type;
          row.grantRemark = typeName;
          return update(row);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
